import React, {Component} from 'react'
import {Col, Form, Input, Row} from 'antd'
import {strVal} from '../../../modules/Utils'
import {get} from 'lodash'

const {TextArea} = Input

class ProgramForm extends Component {
  render() {
    const formItemLayoutRow = {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16},
      },
    }
    const {getFieldDecorator} = this.props.form
    const {program} = this.props

    return (
      <Form layout="horizontal">
        <Row>
          <Col span={24}>
            <Form.Item label="Program Title" {...formItemLayoutRow}>
              {getFieldDecorator('program.title', {
                initialValue: strVal(program, 'program.title'),
                rules: [
                  {required: true, message: "Program Title can't be empty "},
                ],
              })(<Input placeholder="Title" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item label="Description" {...formItemLayoutRow}>
              {getFieldDecorator('program.description', {
                initialValue: get(program, 'description'),
              })(<TextArea placeholder="Description" rows={4} />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default Form.create()(ProgramForm)
